import { render } from "./SolucaoVisualizar.vue?vue&type=template&id=2219a099"
import script from "./SolucaoVisualizar.vue?vue&type=script&lang=js"
export * from "./SolucaoVisualizar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__